import { useEffect } from "@wordpress/element";
import { Button } from "@wordpress/components";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { useDispatch } from "react-redux";
import { settings } from "settings";
import { resetEventBooking } from "store/vino/eventBookingSlice";

const EventPackageCard = ({ event }) => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(resetEventBooking());
	}, []);

	const handleNavigate = () => {
		window.location.href = `${settings.urls.eventBooking}?eventId=${event.id}`;
	};

	return (
		<Card className="relative rounded-16">
			<div className="pt-48 pb-24 text-center">
				<Typography
					variant="subtitle1"
					color="inherit"
					className="text-20 font-semibold"
				>
					{event.name}
				</Typography>
			</div>

			<CardContent className="text-center p-0">
				<div className="flex flex-col">
					<div className="flex justify-center mb-8">
						<Typography
							variant="h5"
							color="textSecondary"
							className="font-semibold"
						>
							$
						</Typography>
						<div className="flex items-end">
							<Typography className="text-72 mx-4 tracking-tight font-semibold leading-none">
								<span className="text-20 mx-4 tracking-tight font-semibold leading-none">
									{event.costPerPerson ? parseInt(event.costPerPerson) : ""}
								</span>
							</Typography>
							<Typography
								variant="subtitle1"
								color="textSecondary"
								className="font-normal"
							>
								/ guest
							</Typography>
						</div>
					</div>
				</div>
				<Divider className="my-32" />
				<div className="flex flex-col p-32">
					<Typography variant="subtitle1" className="mb-8"></Typography>
				</div>
			</CardContent>

			<div className="flex justify-center pb-32">
				<Button variant="outlined" onClick={handleNavigate} className="w-128">
					Book Now
				</Button>
			</div>
		</Card>
	);
};

export default EventPackageCard;
